interface BrandProps {
  size?: 'sm' | 'md';
}

export function Brand({ size = 'md' }: BrandProps) {
  const h = size === 'sm' ? 28 : 40;
  return (
    <div className="flex items-center gap-2">
      <img
        src="https://cdn11.bigcommerce.com/s-95dt7a7/images/stencil/250x100/big-logo_1676579048__48881.original.png"
        alt="Circuit Board Medics"
        height={h}
        style={{ height: h, width: 'auto' }}
        loading="lazy"
      />
    </div>
  );
}
